import { useEffect, useState } from 'react'
import {
  getShowCase,
  ShowcasePageName,
} from 'src/services/marketplace-api/vitrines'
import { RelatedProductResponse } from 'src/services/searchProducts/dtos'

type ProductShowcaseParams = {
  productId?: number
  categorySlug?: string
  subcategorySlug?: string
  cartId?: string | number
}

export const useProductShowcases = (
  name: ShowcasePageName,
  params?: ProductShowcaseParams
) => {
  const [showcases, setShowcases] = useState<RelatedProductResponse>({
    top: [],
    middle: [],
    bottom: [],
  })

  useEffect(() => {
    getShowCase(name, {
      productId: params?.productId,
      categorySlug: params?.categorySlug,
      subcategorySlug: params?.subcategorySlug,
      cartId: params?.cartId,
    })
      .then((showcases) => {
        setShowcases(showcases)
      })
      .catch(() => {
        setShowcases({ top: [], middle: [], bottom: [] })
      })
  }, [
    name,
    params?.productId,
    params?.categorySlug,
    params?.subcategorySlug,
    params?.cartId,
  ])

  return {
    showcaseTop: showcases?.top,
    showcaseMiddle: showcases?.middle,
    showcaseBottom: showcases?.bottom,
  }
}
